import { Head, router } from '@inertiajs/react'
import { Building2, LogOut } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export default function NoOrganization() {
  const handleLogout = () => {
    router.delete('/session')
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Head title="Sem Organização" />
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-muted">
            <Building2 className="size-6 text-muted-foreground" />
          </div>
          <CardTitle>Sem acesso a organizações</CardTitle>
          <CardDescription>
            Você não possui acesso a nenhuma organização. Entre em contato com um
            administrador para ser adicionado a uma organização.
          </CardDescription>
        </CardHeader>
        <CardContent />
        <CardFooter className="justify-center">
          <Button variant="outline" onClick={handleLogout}>
            <LogOut className="mr-2 size-4" />
            Sair
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
